import { ProposalCopyingForRecalConstant } from "presentation/constant/ProposalCopyingForRecal/ProposalCopyingForRecalConstant";
import { standardProposalTariffItemRequiredFieldList } from "presentation/constant/StandardProposal/StandardProposalConstant";
import { useProposalCopyingForRecalVM } from "presentation/hook/ProposalCopyingForRecal/useProposalCopyingForRecalVM";
import { useProposalCopyingForRecalTracked } from "presentation/store/ProposalCopyingForRecal/ProposalCopyingForRecalProvider";
import { CriteriaItemContainer } from "presentation/view/components/CriteriaItemContainer";
import { NbisCommonField } from "presentation/view/components/NbisCommonField";
import { memo, useMemo } from "react";
import { FieldType, IFieldValue } from "veronica-ui-component/dist/component/core";
import { Sidebarheader } from "veronica-ui-component/dist/component/core/styled/uiFramework.styled";

const TariffItemForRecalHeaderBar: React.FC = () => {
    const SCREEN_CONSTANT = ProposalCopyingForRecalConstant.Table;
    const [proposalCopyingForRecalState] = useProposalCopyingForRecalTracked();
    const proposalCopyingForRecalVM = useProposalCopyingForRecalVM();
    const { currentItemRow } = proposalCopyingForRecalState;

    const memoTariffType = useMemo(() =>
        <div className='im-flex-row-item' style={{ width: "180px", marginTop: "10px", marginBottom: "10px", marginLeft: "10px" }}>
            <NbisCommonField
                errorMessages={{}}
                isReadOnly={true}
                isShowOptional={false}
                readOnlyValue={currentItemRow?.tariffType || ''}
                fieldValue={currentItemRow?.tariffType}
                fieldLabel={SCREEN_CONSTANT.TARIFF_TYPE}
                isSaveClicked={false}
                fieldType={FieldType.DROPDOWN}
                fieldKey={'tariffType'}
                maxLength={60}
                options={[]}
                requiredFieldList={standardProposalTariffItemRequiredFieldList}
                onFieldChange={(fieldKey: string, fieldValue: IFieldValue, fFullValue?: any) =>
                    proposalCopyingForRecalVM.onFieldChange(fieldKey, fieldValue && fieldValue.toString(), fFullValue)} />
        </div>
        , [SCREEN_CONSTANT.TARIFF_TYPE, currentItemRow?.tariffType, proposalCopyingForRecalVM])

    const memotariffCode = useMemo(() =>
        <div className='im-flex-row-item' style={{ width: "180px", marginTop: "10px", marginBottom: "10px", marginLeft: "10px" }}>
            <NbisCommonField
                errorMessages={{}}
                isReadOnly={true}
                isShowOptional={false}
                readOnlyValue={currentItemRow?.tariffCode || ''}
                fieldValue={currentItemRow?.tariffCode}
                fieldLabel={SCREEN_CONSTANT.TARIFF_CODE}
                isSaveClicked={false}
                fieldType={FieldType.DROPDOWN}
                fieldKey={'tariffCode'}
                maxLength={60}
                options={[]}
                requiredFieldList={standardProposalTariffItemRequiredFieldList}
                onFieldChange={(fieldKey: string, fieldValue: IFieldValue, fFullValue?: any) =>
                    proposalCopyingForRecalVM.onFieldChange(fieldKey, fieldValue && fieldValue.toString(), fFullValue)} />
        </div>
        , [SCREEN_CONSTANT.TARIFF_CODE, currentItemRow?.tariffCode, proposalCopyingForRecalVM])


    const memoForwarderCode = useMemo(() =>
        <div className='im-flex-row-item' style={{ width: "180px", marginTop: "10px", marginBottom: "10px", marginLeft: "10px" }}>
            <NbisCommonField
                errorMessages={{}}
                isReadOnly={true}
                isShowOptional={false}
                readOnlyValue={currentItemRow?.forwarderCode || ''}
                fieldValue={currentItemRow?.forwarderCode}
                fieldLabel={SCREEN_CONSTANT.FORWARDER_CODE}
                isSaveClicked={false}
                fieldType={FieldType.DROPDOWN}
                fieldKey={'forwarderCode'}
                maxLength={60}
                options={[]}
                requiredFieldList={standardProposalTariffItemRequiredFieldList}
                onFieldChange={(fieldKey: string, fieldValue: IFieldValue, fFullValue?: any) =>
                    proposalCopyingForRecalVM.onFieldChange(fieldKey, fieldValue && fieldValue.toString(), fFullValue)} />
        </div>
        , [SCREEN_CONSTANT.FORWARDER_CODE, currentItemRow?.forwarderCode, proposalCopyingForRecalVM])



    return <Sidebarheader style={{ width: '100%' }}>
        <CriteriaItemContainer>
            {memoTariffType}
            {memotariffCode}
            {memoForwarderCode}
        </CriteriaItemContainer>
    </Sidebarheader>
}

export default memo(TariffItemForRecalHeaderBar);